import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Dashboard from '../../components/Dashboard';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import UserList from '../../components/Users/UserList';
import { push } from 'connected-react-router';
import { getList, getUserTypes, deleteUser } from '../../redux/modules/user/action';

const ROWS_PER_PAGE = 10;
const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  }
});

class Users extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    userList: PropTypes.array,
    classes: PropTypes.object
  }

  state = {
    page: 0,
    rowsPerPage: ROWS_PER_PAGE,
    roleId: this.props.match.params.roleId
  };

  async componentDidMount () {
    const { dispatch, match } = this.props;
    const { page, rowsPerPage } = this.state;
    const roleId = match.params.roleId;
    if (roleId) {
      await dispatch(getList(page, rowsPerPage, roleId));
    } else {
      await dispatch(getList(page, rowsPerPage));
    }

    await dispatch(getUserTypes());
  }

  componentWillReceiveProps (props) {
    const { dispatch, match } = props;
    const { page, rowsPerPage, roleId } = this.state;
    
    if (match.params.roleId !== roleId) {
      dispatch(getList(page, rowsPerPage, match.params.roleId));
      this.setState({ roleId: match.params.roleId });
    }
  }

  viewUser = (userId) => {
    const { dispatch } = this.props;    
    dispatch(push(`/user/view-user/${userId}`));
  }
  
  updateUser = (userId) => {
    const { dispatch } = this.props;    
    dispatch(push(`/user/edit-user/${userId}`));
  }

  handleChangePage = (event, page) => {
    const { dispatch, match } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({ page });
    dispatch(getList(page, rowsPerPage, match.params.roleId));
  };
  
  handleChangeRowsPerPage = event => {
    const { dispatch, match } = this.props;
    const { page } = this.state;
    this.setState({ rowsPerPage: event.target.value });
    dispatch(getList(page, event.target.value, match.params.roleId));
  };

  removeUser = (userId) => {
    const { dispatch } = this.props;
    dispatch(deleteUser(userId));
  };

  render () {
    const { userList, classes, match, userTypes, totalUsers } = this.props;
    const { rowsPerPage, page } = this.state;

    return (
      <Dashboard>
        <React.Fragment>
        <h3>{ match.params.roleId === '1' ? 'Roomers' : 'Vacancy Providers'}</h3>
          <Paper className={classes.root}>
            <UserList
              list={userList}
              viewUser={this.viewUser}
              updateUser={this.updateUser}
              handleChangePage={this.handleChangePage}
              handleChangeRowsPerPage={this.handleChangeRowsPerPage}
              rowsPerPage={rowsPerPage}
              page={page}
              totalRecords={totalUsers}
              userTypes={userTypes}
              removeUser={this.removeUser}
            />
          </Paper>
        </React.Fragment>
      </Dashboard>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userList: state.user.list,
    userTypes: state.user.userTypes,
    totalUsers: state.user.totalUsers,
  }
}

export default connect(mapStateToProps)(withStyles(styles)(Users));
